import type { Integration } from '../types';
import * as WebhooksFeature from '../domains/webhooks/feature';

export const webhooks: Integration = {
  slug: 'webhooks',
  icon: 'webhooks',
  name: 'integrations:webhooks.integrations-page.title',
  provider: 'integrations:card.hotjar',
  tokenName: null,
  actionLabel: {
    enable: 'integrations:webhooks.integrations-page.button-action.enable',
  },
  description: 'integrations:webhooks.integrations-page.description',
  descriptionLarge: 'integrations:webhooks.integrations-page.description-large',
  resources: [
    {
      copy: 'integrations:webhooks.integrations-page.key-benefits',
      url: 'https://www.hotjar.com/integrations/webhooks/',
      icon: 'page_full',
    },
    {
      copy: 'integrations:webhooks.integrations-page.using-with-hotjar',
      url: 'https://www.hotjar.com/integrations/webhooks/',
      icon: 'page_full',
    },
  ],
  images: [],
  videoUrl: null,
  askGate: WebhooksFeature.GATE_FEEDBACK,
  settings: null,
  isBeta: false,
  featureFlag: WebhooksFeature.FEATURE_NAME,
  isEnabled: true,
  isAlwaysOn: true,
  installUrl: '',
};
